import React from 'react';
import NumberFormat from "react-number-format";
import CalculateAddressShipping from './CalculateAddressShipping';
import DisplayInfo from './DisplayInfo';
import Helper from './Helper';
import ProductAmountUpdate from './ProductAmountUpdate';

class ProductDetail extends React.Component {
    handleUpdateAmount = (amount)=>{
      this.props.handleUpdateAmount(amount);
    }

    handleAddtoWishlist = (productId)=>{
      this.props.handleAddtoWishlist(productId);
    }

    handleSelectAddress = () => {

    }

    render(){
        let {info, wishlist, productAmount, product} = this.props,
        {rating} = info,
        rating_view = [];

        let discountPercent = 0;
        if(!info.meta.discount && info.meta.price > info.price_after_discount){
          discountPercent = (info.meta.price - info.price_after_discount)/info.meta.price;
          info.meta.discount = discountPercent;
        }
        let statusLabel = info.product_status ? 
        <label className={`badge py-2 text-md badge-${info.status_types.badge} font-weight-bold`}>{info.status_types.title}</label>:<label></label>
        Helper.countDown(info.event_to_date);
        let avgRating = rating.length ? rating.reduce((c,n)=>parseInt(c)+parseInt(n.number), 0)/rating.length:0;
        avgRating = Math.round(avgRating);
        for (let i = 0; i < 5; i++) {
            let grayscale = avgRating <= i ? 'grayscale':''
            rating_view.push(
            <img key={i}
                src={Helper.getSiteUrl() + "/resource/images/ico_star_yellow.svg"}
                className={`rating ${grayscale}`}
            />);
        }

        let finalRatingCount = rating.length;
        let dump_data = product.dump_data;
        if(dump_data) {
          let {star_1, star_2, star_3, star_4, star_5, avg_rating, sell_count} = dump_data;
          avgRating = dump_data.avg_rating;
          finalRatingCount += star_1 + star_2 + star_3 + star_4 + star_5;
        }

        let wishlist_button = wishlist &&
        wishlist.some(item=>item.postid === info.product_id) ?
        <div className="col-4 text-right">
            <a href="/danh-sach-yeu-thich" title="Danh sách yêu thích"
            className="product-wishlist-items">
                <i className="fas fa-heart" />
            </a>
        </div>:
        <div className="col-4 text-right">
            <span onClick={()=>this.handleAddtoWishlist(info.product_id)} title="Cho vào danh sách yêu thích" 
            className="product-wishlist-add">
                <i className="far fa-heart" />
            </span>
        </div>;
        return (
            <div className="product-detail-wrap__main">
              <h1 style={{fontSize:'1.5rem'}}>{info.title}</h1>
              <div className="row justify-content-between product-detail-wrap__main__info">
                <div className="col-6">
                  <label>Nhà xuất bản: </label> 
                  <a href='/'>{info.nxb}</a>
                </div>
                <div className="col-6">
                  <label>Tác giả: </label> 
                  <a href={info.tacgia_url}>{info.tacgia}</a>
                </div>
                <div className="col-6">
                  <label>Nhà phát hành: </label> 
                  <a href={info.nph_url}>{info.nph}</a>
                </div>
                <div className="col-6">
                  {statusLabel}
                </div>
              </div>
              {info.event_name === 'flashsale' ? 
              <div className="align-items-center product-detail-flashsale no-gutters row">
                  <div className="col-12 col-md-4">
                    <img src={Helper.getSiteUrl() + "/resource/images/banner_flash_sale.png"} alt="Pibook.vn|Flashsale"
                    className="img-fluid" />  
                  </div>
                  <div className="col-12 col-md-8">
                    <span>Kết thúc trong: </span>
                    <span className="mr-3" id="countdown-timer-2">
                    </span>
                    <span>
                      Đã bán:  <strong className="text-danger">{info.event_out_stock}</strong>/
                      <strong>{info.event_in_stock}</strong>
                    </span>
                  </div>  
              </div>
              :null}
              {/* <div className="product-detail-wrap__rating">
                {rating_view} <span className="rating-span">({rating.length ?? 0} Đánh giá)</span>
              </div> */}
              <DisplayInfo 
                rating={avgRating}
                ratingCount={finalRatingCount}
                sellCount={dump_data?.sell_count ? (dump_data.sell_count + product.sell_count) : product.sell_count}
              />

              <div className="product-detail-wrap__price row justify-content-center my-2">
                <div className="col-md-8 position-relative">
                    <span className="product-price">
                    <NumberFormat
                      value={Math.ceil(info.price_after_discount)}
                      thousandSeparator="."
                      decimalSeparator=","
                      displayType={"text"}
                      renderText={(value) => `${value} đ`}
                    />
                    </span>
                  {info.meta.price > info.price_after_discount ? (
                    <span className="product-price-origin pl-3">
                      <NumberFormat
                        value={Math.ceil(info.meta.price)}
                        thousandSeparator="."
                        decimalSeparator=","
                        displayType={"text"}
                        renderText={(value) => `${value}đ`}
                      />
                    </span>
                  ) : <p className="pl-3">&nbsp;</p>}
                  {info.meta.discount ? (
                  <span className="product-discount">
                    -{info.meta.discount <= 1 ? (
                      `${Math.ceil(info.meta.discount * 100)}%`
                    ) : (
                      <NumberFormat
                        value={Math.round(info.meta.discount)}
                        thousandSeparator="."
                        decimalSeparator=","
                        displayType={"text"}
                        renderText={(value) => `-${value}đ`}
                      />
                    )}
                  </span>
                ) : null}
                </div>
                
                {wishlist_button}
              </div>
              <div>
                {info.out_of_stock ? (
                <span className="p-2 badge badge-danger">Hết hàng</span>
                ) : 
                <div className="product-quantity">
                    <div id="catalog-product-details-discount">
                        <div className="product-view-quantity-box d-flex">
                            <label>Số lượng:</label>
                            <ProductAmountUpdate info={info} productAmount={productAmount} handleUpdateAmount={this.handleUpdateAmount} />
                        </div>
                    </div>
                  </div>
                }
              </div>

              <CalculateAddressShipping 
                selectedCity={"01"}
                selectedWard={"004"}
                handleChangeForm={this.handleSelectAddress}
                selectedDistrict={"004"}
                city="city" district="district" address="address"
                addressText={""} requiredAddress={false}
                totalWeight={product.info.weight * productAmount}
                hideHouseNumber
                hideWard
                title={"Vận chuyển: "}
                />

              <div className="promotion-wrap mt-3">
                <h5 className="p-2">Thông tin khuyến mại</h5>
                <div className="promotion-wrap__content" dangerouslySetInnerHTML={{__html: info.promotion}} />
              </div>
            </div>
        )
    }
}
export default ProductDetail;